// React libraries
import * as React from 'react';
// Custom Styles
import { useStyles } from "./KeyboardNumberModalStyles";
// Material-UI Core
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Modal } from "../../index";
import { GreyButton } from "../../index";
// Icon
import Backspace from "../../../icons/Backspace/Backspace";
export const KeyboardNumberModal = (props) => {
    const classes = useStyles(props);
    const { isModalOpen, title, setInitialValue, setOpenModalState, initialValue, dateModal } = props;
    const [display, setDisplay] = React.useState("");
    const [isConfirmed, setIsConfirmed] = React.useState(false);
    React.useEffect(() => {
        setDisplay(initialValue);
    }, [initialValue, isModalOpen]);
    React.useEffect(() => {
        checkIsConfirmed();
    }, [display]);
    const handleAppendChange = (value) => {
        setDisplay(display.concat(value));
    };
    const handleEraseChange = () => {
        setDisplay(display.substring(0, display.length - 1));
    };
    const checkIsConfirmed = () => {
        if (dateModal) {
            if (display.length === 6) {
                setIsConfirmed(true);
            }
            else {
                setIsConfirmed(false);
            }
        }
        else {
            if (display.length > 0) {
                setIsConfirmed(true);
            }
            else {
                setIsConfirmed(false);
            }
        }
    };
    const modalWidth = 285;
    const modalHeight = 350;
    return (React.createElement(Modal, { isModalOpen: isModalOpen, width: modalWidth, height: modalHeight },
        React.createElement("div", { className: classes.floatingDiv },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivBarTop },
                    React.createElement("p", null, title)),
                React.createElement(Grid, { item: true, md: 12, className: classes.keyboardDisplay },
                    React.createElement("p", null, display)),
                React.createElement(Grid, { item: true, md: 12, className: classes.keyboardButtonDiv },
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(1) },
                                React.createElement("p", null, "1"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(2) },
                                React.createElement("p", null, "2"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(3) },
                                React.createElement("p", null, "3"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(4) },
                                React.createElement("p", null, "4"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(5) },
                                React.createElement("p", null, "5"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(6) },
                                React.createElement("p", null, "6"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(7) },
                                React.createElement("p", null, "7"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(8) },
                                React.createElement("p", null, "8"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(9) },
                                React.createElement("p", null, "9"))),
                        React.createElement(Grid, { item: true, md: 4 }, dateModal ? (React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange("") },
                            React.createElement("p", null, ""))) : (React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(".") },
                            React.createElement("p", null, ".")))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleAppendChange(0) },
                                React.createElement("p", null, "0"))),
                        React.createElement(Grid, { item: true, md: 4 },
                            React.createElement(Button, { className: classes.keyboardButton, onClick: () => handleEraseChange() },
                                React.createElement(Backspace, { style: { color: "black" } }))))),
                React.createElement(Grid, { item: true, md: 6, className: classes.floatingDivBarBottom },
                    React.createElement(GreyButton, { type: "left", onClick: () => { setOpenModalState(false); setDisplay(initialValue); } }, "Cancel")),
                React.createElement(Grid, { item: true, md: 6, className: classes.floatingDivBarBottom },
                    React.createElement(GreyButton, { type: "right", onClick: () => { setInitialValue(display); setOpenModalState(false); setDisplay(""); }, disabled: !isConfirmed }, "Confirm"))))));
};
KeyboardNumberModal.defaultProps = {
    setInitialValue: () => { },
    setOpenModalState: () => { },
    initialValue: "",
    dateModal: false
};
export default React.memo(KeyboardNumberModal);
